<template>
  <div :class="svgContainerClass(attributes.value)" :source="noOfSource" :style="{maxWidth: attributes.maxWidth}">
    <st-get-svg
      v-if="platform"
      :class="`st-${platform}-svg`"
      :rootFolder="attributes.value"
      :platform="platform"
      @onGetSvg="onGetSvg"></st-get-svg>
  </div>
</template>

<script>
import $ from 'jquery'
import StGetSvg from './StGetSvg.vue'
import 'scss/modules/_animate.scss'
import 'waypoints/lib/noframework.waypoints'

const d3 = Object.assign({}, require('d3-selection'), require('d3-transition'), require('d3-collection'), require('d3-timer'))

const oTypeAnimations = {
  'animate-up': 'slideUp',
  'animate-down': 'slideDown',
  'animate-left': 'slideLeft',
  'animate-right': 'slideRight',
  'animate-fadeIn': 'fadeIn',
  'animate-fadeOut': 'fadeOut',
  'animate-line': 'animatePath'
}

$.extend($.fn, {
  animateCss: function (animationName, type) {
    var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend'
    var _this = this
    if (type !== undefined) {
      if (type === 'in') {
        d3.timeout(function () {
          _this.removeClass('none')
        }, 100)
      }
    }
    this.addClass('animated ' + animationName).one(animationEnd, function () {
      _this.off()
      if (type === 'out') _this.addClass('none')
      _this.removeClass('animated ' + animationName)
    })
  }
})

export default {
  props: ['attributes'],
  components: {StGetSvg},
  data () {
    return {
      initWidth: null,
      animateName: null,
      element: null
    }
  },
  computed: {
    noOfSource () {
      return parseInt(this.attributes.source) || 3
    },
    platform () {
      const {noOfSource, initWidth} = this
      if (!initWidth) return null
      switch (noOfSource) {
        case 4:
          if (initWidth >= 1200) return 'big'
          if (initWidth >= 960) return 'desktop'
          if (initWidth >= 550) return 'tablet'
          break
        case 3:
          if (initWidth >= 960) return 'desktop'
          if (initWidth >= 550) return 'tablet'
          break
        case 2:
          if (initWidth >= 550) return 'tablet'
          break
      }
      return 'mobile'
    }
  },
  mounted () {
    this.initWidth = this.$window.innerWidth
  },
  methods: {
    onGetSvg (svgElem) {
      let newTag = (typeof svgElem === 'object') ? d3.select(svgElem) : d3.selectAll(svgElem)
      if (newTag.size() === 0) return

      let animate = false
      Object.keys(oTypeAnimations).forEach(key => {
        if (newTag.classed(key)) {
          animate = true
          this.animateName = oTypeAnimations[key]
        }
      })

      if (!animate) {
        Object.keys(oTypeAnimations).forEach(key => {
          if (newTag.selectAll('.' + key).size() > 0) {
            animate = true
            newTag = newTag.selectAll('.' + key)
            this.animateName = oTypeAnimations[key]
          }
        })
      }

      const _this = this
      newTag.each(function () {
        _this.element = this
        if (_this.animateName === 'animatePath') {
          const elem = ['path', 'polyline'].includes($(this)[0].tagName) ? $(this)[0] : $(this).find('path,polyline')[0]

          const d3Elem = $(this)[0].tagName === 'path' ? d3.select(this) : d3.select(this).select('path')
          const totalLength = d3.select(elem).node().getTotalLength()
          d3Elem.attr('stroke-dasharray', totalLength).attr('stroke-dashoffset', totalLength)
        }

        const {animateName, element} = _this
        /* eslint no-new: "off" */
        new Waypoint({
          element: element,
          handler (direction) {
            if (direction === 'down') {
              if (animateName !== 'animatePath') {
                if (animateName) {
                  $(element).animateCss(animateName, 'in')
                }
              } else {
                const d3Elem = $(element)[0].tagName === 'path' ? d3.select(element) : d3.select(element).select('path')
                const totalLength = d3Elem.node().getTotalLength()
                d3Elem.attr('stroke-dashoffset', totalLength)
                d3Elem.transition().duration(3000).attr('stroke-dashoffset', 0)
              }
            } else if (direction === 'up') {
              if (animateName === 'animatePath') {
                const d3Elem = $(element)[0].tagName === 'path' ? d3.select(element) : d3.select(element).select('path')
                d3Elem.transition().duration(100).attr('stroke-dashoffset', 0)
              }
            }
          },
          offset: '100%'
        })
      })
    },
    svgContainerClass (path) {
      return {
        'svg-wrapper': true,
        [path.split('/').join('-')]: true
      }
    }
  }
}
</script>

<style lang="scss">
.svg-wrapper {
  svg {
    display: block;
  }
}
</style>
